import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import EntityInterface, {
  Appearance,
} from 'common/types/entities/EntityInterface'
import React from 'react'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { useUpdateEntity, useUpdateProp } from '../hooks/useUpdateProps'
import DeviceAppearance from '../options/DeviceAppearance/DeviceAppearance'
import HtmlAttrId from '../options/HtmlAttrId'

type OfferThankYouOrderSummarySettingsNewProps = {
  entity: EntityInterface
}

function OfferThankYouOrderSummarySettingsNew({
  entity,
}: OfferThankYouOrderSummarySettingsNewProps) {
  const { isMobile } = useDeviceModeContext()
  const updateEntity = useUpdateEntity<EntityInterface>()
  const updateProp = useUpdateProp(entity)

  function updateAppearance(appearance: Appearance) {
    updateEntity({
      ...entity,
      appearance,
    })
  }
  return (
    <>
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
        withoutHorizontalLine
      />
      <DeviceAppearance
        update={updateAppearance}
        desktop={entity.appearance.desktop}
        mobile={entity.appearance.mobile}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default OfferThankYouOrderSummarySettingsNew
